import React from "react";
import DoglinkElement from "./DoglinkElement";
import icons from "../helpers/icons";
import VismerKnappen from "./VismerKnappen";
import Error from "./Error";


const SearchResults = ({errorText, isLoading, antallSider, antallTreff, hunder, sideNr, sisteHunder, loadMoreData}) => {

    //  list of searched dogs here

    const addToolbar = () => {
        document.getElementById("tool-bar").classList.remove("hideTool");
    };


    const renderSisteHunder = () => {
        if (sisteHunder === undefined || sisteHunder.length === 0) return null;

        const SisteHunder = sisteHunder.map(f =>
            <DoglinkElement
                key={f.hundId}
                linkTo={`/hund?id=${f.hundId}`}
                iconFirst={icons.bookmark}
                iconLast={icons.arb}
                data={f}
                onClick={addToolbar}
            />
        );

        return (
            <li>
                <strong>DE SENESTE VISTE HUNDE</strong>
                <ul>
                    {SisteHunder}
                </ul>
            </li>

        )
    }

    const renderResults = () => {
        if (errorText !== null)
            return <Error>{errorText}</Error>

        if ((sisteHunder === undefined || sisteHunder === null) && antallTreff === null)
            return null;


        const ret = hunder.map(res =>
            //const ret = hunder.map(res =>
            <DoglinkElement
                key={res.hundId}
                linkTo={`/hund?id=${res.hundId}`}
                iconFirst={icons.bookmark}
                iconLast={icons.arb}
                data={res}
                onClick={addToolbar}
            />
        );




        return(
            <div className="results-container">
                <div className="results-list">
                    {
                        antallTreff !== null &&
                            <span className="antall">Antal: {antallTreff}</span>
                    }

                    <ul className="doglinks-list">
                        { ret }
                        <VismerKnappen
                            total={antallTreff}
                            maxStep="20"
                            renderedAmount={hunder.length}
                            incrementer={loadMoreData}
                        />

                        { antallTreff === null &&
                            renderSisteHunder()
                        }
                    </ul>
                </div>
            </div>
        )
    }

    return (
        <div className="results-container">
            { renderResults() }
        </div>
    )


};


export default SearchResults;